import React from 'react';
import { Hero } from '../components/Hero';
import { HomeCallMoment } from '../components/HomeCallMoment';
import { ValueStrip } from '../components/ValueStrip';
import { NextStepPanel } from '../components/NextStepPanel';
import { usePageTitle } from '../hooks/usePageTitle';
export function Home() {
  usePageTitle('Viridia Analytics | Your team already pays for the tools. I make them produce.');
  return <>
      <Hero data-id="element-458" data-mp="1zj8xv3yzpb35" />
      <HomeCallMoment data-id="element-459" data-mp="1zjii0axcso0x" />
      <ValueStrip data-id="element-460" data-mp="1zkactjj4mhq5" />
      <NextStepPanel title="Already tried an AI assistant and turned it off? Good. See why this is not that." buttonLabel="Why this is different" to="/why" secondaryLabel="Or book the free Response Audit" secondaryTo="/book" data-id="element-461" data-mp="24gsbc1nv5ju1" />
    </>;
}